import {castShadow} from "../styles/global";

export default function Home() {

    return (
        <div className={"col max-width align-center"}>
            <img
                className={'portrait-img'}
                src={'thumbs_up_portrait.png'}
            />
            <div
                style={{
                    ...castShadow
                }}
                className={"br-15p bg-white p-40p"}
            >
                <h1>
                    I am Paddleboat
                </h1>
                <p>
                    I am a Full stack software developer, artist, and game developer!

                    All the bitches I have ever gotten have been a result of being vulnerable to some degree, and not being afraid of being a <a>little bitch</a>.
                    Being a little bitch is just not accepting aboout how bad a person you can let yourself be, but you need to realize that you live in a society,
                    where knowing your average man means knowing in how we cannot be perfect. I don't think the perfect Christian exits. I am not perfect. I will mess up
                    I will suck ass. I have sucked ass in the past, and why shouldn't I continue in the future. I'm ready. I'm ready to not suck ass I think. And unfortunately,
                    when I turn my safeguards off I find myself not perfect. But I am not bad. My motivation that runs my engine depends on this knowledge that I will never meat this
                    variable of perfection. It motivates me to be a better person always. And I hope this motivation makes a better person. Because this is the motto I must live by
                </p>
            </div>
        </div>
    )
}